<script setup lang="ts">
import CheckboxComponent from "@/stories/form/Checkbox/CheckboxComponent.vue";

interface Props {
  src: string;
  alt: string;
  checked?: boolean;
}

withDefaults(defineProps<Props>(), {
  checked: false,
});

defineEmits<{
  toggle: [];
}>();
</script>

<template>
  <button
    type="button"
    :class="[
      'w-full rounded-md overflow-hidden relative max-h-[8.375rem]',
      'focus-visible-strong focus-visible:outline-offset-1',
      checked && 'outline outline-2 outline-neutral1000',
    ]"
    @click="$emit('toggle')"
  >
    <img
      :src="src"
      :alt="alt"
      class="h-[8.375rem] max-h-[8.375rem] w-full object-cover rounded-md border border-neutral300"
    />

    <CheckboxComponent
      v-if="checked"
      checked
      class="absolute right-2 bottom-2"
      :tabindex="-1"
      :size="'lg'"
    />
  </button>
</template>
